import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Home, Building } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-24 bg-primary relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="" className="w-full h-full object-cover" />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          <div className="text-center text-white mb-12">
            <h2 className="text-4xl font-monomakh mb-6">Qual è il Tuo Prossimo Capitolo?</h2>
            <p className="text-xl text-gray-200">
              Che tu stia cercando la casa dei tuoi sogni, un investimento sicuro, o desideri vendere il tuo 
              immobile al miglior prezzo, siamo qui per trasformare le tue aspettative in realtà.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 hover:bg-white/15 transition-colors">
              <div className="bg-secondary text-white w-14 h-14 rounded-full flex items-center justify-center mb-6">
                <Home className="h-7 w-7" />
              </div>
              <h3 className="text-2xl font-semibold text-white mb-4">Cerchi Casa?</h3>
              <p className="text-gray-200 mb-8">
                Scopri la nostra selezione di immobili esclusivi, scelti con cura per soddisfare ogni esigenza 
                e desiderio. Il tuo sogno abitativo è a portata di click.
              </p>
              <Link
                to="/immobili"
                className="inline-flex items-center bg-white text-primary hover:bg-gray-100 px-6 py-3 rounded-lg transition-colors font-semibold"
              >
                Trova il tuo immobile
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 hover:bg-white/15 transition-colors">
              <div className="bg-secondary text-white w-14 h-14 rounded-full flex items-center justify-center mb-6">
                <Building className="h-7 w-7" />
              </div>
              <h3 className="text-2xl font-semibold text-white mb-4">Vuoi Vendere?</h3>
              <p className="text-gray-200 mb-8">
                Affidati alla nostra esperienza per valorizzare al massimo il tuo immobile. Valutazione gratuita, 
                marketing strategico e una rete di acquirenti selezionati.
              </p>
              <Link
                to="/vendi-con-noi"
                className="inline-flex items-center bg-secondary text-white hover:bg-secondary-light px-6 py-3 rounded-lg transition-colors font-semibold"
              >
                Scopri come vendere
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;